import GenericModel from '../generic-model';

export default class ProductSize extends GenericModel {
  width: number;
  height: number;
  productionPrice: string;
  placementPrice: string;
  type?: string;
  designerMinutes?: number;
  placerMinutes?: number;
  editable?: boolean;
}
